module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town")]), _vm._v(" "), _c('p', {
    staticClass: "ctr",
    attrs: {
      "id": "pz13-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#RR_10",
      "id": "CC_10"
    }
  }, [_vm._v(" Floyd’s Punch in the Mouth")])]), _vm._v(" "), _c('p', {
    staticClass: "tx6",
    attrs: {
      "id": "pz13-10"
    }
  }, [_c('i', [_vm._v(" Not in the nose this time. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pz13-11"
    }
  }, [_c('b', [_vm._v(" 2 quarts water ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pz13-13"
    }
  }, [_c('b', [_vm._v(" 2 cups sugar ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pz13-15"
    }
  }, [_c('b', [_vm._v(" Juice of 2 lemons ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pz13-12"
    }
  }, [_c('b', [_vm._v(" 1 large can pineapple juice ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pz13-14"
    }
  }, [_c('b', [_vm._v(" 2 packages Kool-Aid, any flavor ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pz13-16"
    }
  }, [_c('b', [_vm._v(" 1 large bottle ginger ale ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "pz13-17"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("M")]), _vm._v("ix all ingredients, except ginger ale, and chill. Add chilled ginger ale when ready to serve.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-18"
    }
  }, [_vm._v(" Makes 40 punch cups.")]), _vm._v(" "), _c('p', {
    staticClass: "txrr",
    attrs: {
      "id": "pz13-19"
    }
  }, [_c('i', [_vm._v("Judy B. Coleman—Asheboro, North Carolina")])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "id": "ABm"
    }
  }, [_c('p', {
    staticClass: "tx1a",
    attrs: {
      "id": "pA16"
    }
  }, [_c('i', [_vm._v("Barney’s about to float out of the drugstore:")])]), _vm._v(" "), _c('table', {
    attrs: {
      "id": "pA6M"
    }
  }, [_c('tbody', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "id": "A6M"
    }
  }, [_c('tr', {
    attrs: {
      "id": "tr-A6M-0"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-A6M-0-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("BARNEY:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-A6M-0-1"
    }
  }, [_vm._v("Another root beer float.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-A6M-1"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-A6M-1-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("ELLIE:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-A6M-1-1"
    }
  }, [_vm._v("Barney, don’t you think you’ve had enough?")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-A6M-2"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-A6M-2-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("BARNEY:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-A6M-2-1"
    }
  }, [_vm._v("Ellie, you let me worry about that.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-A6M-3"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-A6M-3-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("ELLIE:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-A6M-3-1"
    }
  }, [_vm._v("But Barney, four inside of fifteen minutes! Putting all that ice cream and soda in your stomach—")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-A6M-4"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-A6M-4-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("BARNEY:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-A6M-4-1"
    }
  }, [_vm._v("Ellie, if you won’t sell them to me, I’ll just buy it some-wheres else.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b43174d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter10.vue
// module id = 93
// module chunks = 0